export default __webpack_public_path__ + "static/media/phone.8640e819.svg";